import script from "./deviceDictSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./deviceDictSelect.vue?vue&type=script&setup=true&lang=js"

import "./deviceDictSelect.vue?vue&type=style&index=0&id=85b99b16&lang=less"

const __exports__ = script;

export default __exports__